// Taten mit Daten logo mark (same as the website's logo-mark.svg):
// the dots take the text colour, the last dot is coral.
export default function LogoMark() {
    return (
        <svg className="logo-mark" viewBox="2 1 62 61" aria-hidden="true" focusable="false">
            <circle cx="6" cy="58" r="4" fill="currentColor"/>
            <circle cx="21.5" cy="52.8" r="5.5" fill="currentColor"/>
            <circle cx="36.8" cy="40.1" r="7.5" fill="currentColor"/>
            <circle cx="50" cy="15" r="14" fill="var(--color-accent)"/>
        </svg>
    );
}
